<template>
  <div class="std-background-blue-2 std-border-radius
  std-pointer card-container d-flex align-center
  font-weight-medium justify-center unselectable std-text-white-1">
    {{text}}
  </div>
</template>

<script>
export default {
  name: "DashGroupTypeInput",
  props: ['text'],
  }
</script>

<style scoped>

.card-container {
  height: 40px;
}

</style>